
import { Options, Vue } from 'vue-class-component'
import { useMetricStore } from '@/stores/metric'
import { MetricService } from '@/bll/service/MetricService'
import Logger from '@/util/logger'

/**
 * @author Ahto Jalak
 * @since 06.02.2023
 */
@Options({
    components: {},
    props: {},
    emits: [],
})
export default class MetricIndex extends Vue {
    private logger = new Logger(MetricIndex.name)
    wishesStore = useMetricStore()
    wishService = new MetricService()

    async mounted (): Promise<void> {
        this.logger.info('mounted')
        // this.wishesStore.$state.metrics =
        //     await this.wishService.getAll()
    }
}

